/**
 * Validações estruturais de comentários em SQLs de integração.
 *
 * A montagem da carga concatena trechos APÓS a query salva; por isso o SQL
 * não pode terminar em comentário de linha (--) ativo nem conter um bloco
 * (/*) aberto sem fechamento — em ambos os casos o complemento concatenado
 * vira comentário e a carga quebra.
 *
 * Usa o tokenizer do sqlRiverFormatter (o mesmo do formatador), que já trata
 * strings multilinha, escapes ('' e \' / \\) e blocos atravessando várias linhas —
 * eliminando os falsos positivos do parser linha-a-linha anterior.
 */
import { tokenize } from "./sqlRiverFormatter";

/**
 * Valida os comentários de um SQL.
 *
 * @param {string} sql
 * @returns {{ ok: true } | { ok: false, motivo: 'comentario-final'|'bloco-aberto' }}
 */
export function validarComentariosSql(sql) {
  const tokens = tokenize(String(sql || ""));

  // /* sem */ comenta tudo o que for concatenado depois da query.
  if (tokens.some((t) => t.type === "bcomment" && !t.fechado)) {
    return { ok: false, motivo: "bloco-aberto" };
  }

  // Último token significativo é um comentário de linha: o -- ativo no fim
  // comenta o complemento da carga (strings com -- e -- dentro de /* */ já
  // saem como tokens string/bcomment, então não geram falso positivo).
  const ultimo = tokens[tokens.length - 1];
  if (ultimo && ultimo.type === "lcomment") {
    return { ok: false, motivo: "comentario-final" };
  }

  return { ok: true };
}

export default validarComentariosSql;
